import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

/* eslint-disable max-len */
var Icon = function Icon() {
  return /*#__PURE__*/_jsxs("svg", {
    "aria-hidden": "true",
    height: "20",
    role: "presentation",
    viewBox: "0 0 20 20",
    width: "20",
    children: [/*#__PURE__*/_jsx("title", {
      children: "TikTok"
    }), /*#__PURE__*/_jsx("path", {
      fill: "currentColor",
      d: "m10.5 0h3.4c.3.1.5.4.5.8 0 .3.1.7.2 1 .4 1.3 1.7 2.6 3.6 2.7.4 0 .6.2.6.6v3c0 .4-.3.6-.7.6-1.2 0-2.4-.3-3.5-.9-.1 0-.1 0-.2-.1v.3 5.3c0 .4 0 .9-.1 1.3-.4 2.5-2.5 4.7-5 5.2-.3.1-.7.1-1 .2h-.8c-.3 0-.6-.1-.9-.1-3.7-.7-6.1-4.5-5-8.1.8-2.8 3.4-4.8 6.2-4.8.4 0 .6.2.6.6v3.2c0 .3-.2.5-.6.6-.1 0-.3 0-.4 0-1.2.2-2.1 1.4-1.8 2.7.2 1.2 1.5 2 2.7 1.8 1.1-.2 1.8-1.1 1.8-2.2 0-4.2 0-8.4 0-12.6-.1-.7 0-1 .4-1.1z"
    })]
  });
};

export default Icon;